import { render, staticRenderFns } from "./BulkEditTasks.vue?vue&type=template&id=61accd74&scoped=true&"
import script from "./BulkEditTasks.vue?vue&type=script&lang=js&"
export * from "./BulkEditTasks.vue?vue&type=script&lang=js&"
import style0 from "./BulkEditTasks.vue?vue&type=style&index=0&id=61accd74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61accd74",
  null
  
)

export default component.exports